const getStringInitials = (str) => {
  const words = str.split(/[\s-_]/); // Split the string by whitespace, dash, and underscore
  const initials = words.map(word => {
    if (word.length === 1) {
      return word.substring(0, 2); // Return the first two letters if the word has only one letter
    } else {
      return word[0]; // Return the first letter of each word
    }
  });
  return initials.join('').toUpperCase(); // Join the initials into a single string
}

export default getStringInitials;